import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import Configs from "../../config"

const Breadcrumb = props => {
  return (
    <Row>
      <Col className="col-12 px-3 mb-2">
        <div className="page-title-box pb-2 d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">{props.breadcrumbItem}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to={`${Configs.appurl}`}>{props.title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#">{props.breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
        {/* <p>
          <span className="text-danger">*</span> If no Year, Month, or Week is
          selected in the date filter, the dashboard (including all gauges and
          charts) will automatically display data from the most recently
          imported spreadsheet of the Current Month & Year.
        </p> */}
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default Breadcrumb
